const mailroomUrl: Record<string, string> = {
  prod: 'https://mailroom.alta.avigilon.com',
  prodeu1: 'https://mailroom.eu.alta.avigilon.com',
  dev: 'https://mailroom.dev.alta.avigilon.com',
  sandbox: 'https://mailroom.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/mailroom',
  test: 'https://mailroom.test.alta.avigilon.com',
};

export const getMailroomUrl = (region: OP.Env): string => {
  return `${mailroomUrl[region]}`;
};
